import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { UserService } from 'app/auth/user.service';
import { Observable } from 'rxjs';

@Injectable()
export class TermsGuard  {
  constructor(
    private router: Router, 
    private user: UserService,
    ) {}

  canActivate() {
      return this.validate();
  }

  private validate() {
      return this.user.getUserInfo().then(({acceptedTerms}) => {
        if(!acceptedTerms){
          this.router.navigate(['privacy-terms']);
        }
        return acceptedTerms
      })
      
  }
}
